import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'shortNumberFormat'
})
export class ShortNumberFormatPipe implements PipeTransform {
  transform(
    value: number,
    minValue: number = 500,
    prefix: string = '',
    suffix: string = '',
    minValueDisplay?: string
  ): string {
    if (value === null || value === undefined) {
      return '';
    }
    if (value < minValue) {
      if (minValueDisplay) {
        return minValueDisplay;
      }
      return `${prefix}<${minValue}${suffix}`;
    }
    if (value < 1000) {
      return `${prefix}${value}${suffix}`;
    }
    if (value < 10000) {
      const k = value / 1000;
      return k % 1 === 0 
        ? `${prefix}${k.toFixed(0)}K${suffix}` 
        : `${prefix}${k.toFixed(1)}K${suffix}`;
    }
    if (value < 1000000) {
      const k = value / 1000;
      return `${prefix}${k.toFixed(0)}K${suffix}`;
    }
    const m = value / 1000000;
    return m % 1 === 0 
      ? `${prefix}${m.toFixed(0)}M${suffix}` 
      : `${prefix}${m.toFixed(1)}M${suffix}`;
  }
}

